export default __webpack_public_path__ + "static/media/vrt.4874cb28.svg";